import {RouterState, connectRouter, routerMiddleware} from 'connected-react-router';
import {History} from 'history';
import {applyMiddleware, combineReducers, compose, createStore} from 'redux';
import thunkMiddleware from 'redux-thunk';

import * as AuthenticationStore from './authenticationStore';
import * as SalesDemosStore from './salesDemosStore';

export interface RootState {
  readonly authentication: AuthenticationStore.State;
  readonly router: RouterState;
  readonly salesDemos: SalesDemosStore.State;
}

export const setupStore = (history: History<any>, preloadState: RootState) => {
  const composeEnhancers = (window as any).__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ || compose;

  return createStore(
    combineReducers<RootState>({
      authentication: AuthenticationStore.reducer,
      router: connectRouter(history),
      salesDemos: SalesDemosStore.reducer
    }),
    preloadState,
    composeEnhancers(applyMiddleware(routerMiddleware(history), thunkMiddleware))
  );
};
